<script>
import i18n from '../i18n.js'
import { dateTimeFormatter } from '../tools.js'
import InlineEditableText from '@/components/InlineEditableText'
import Button from '@/components/Button'
import ImageEnlarger from '@/components/ImageEnlarger'
import ScheduledPublishingTimePicker from '@/components/ScheduledPublishingTimePicker'
import DateUtils from '@/utils/dateUtils'

export default
{
    name: 'cal-even-item',

    props:
    {
        event:
        {
            type: Object,
            required: true
        },

        editable:
        {
            type: Boolean,
            required: true
        }
    },

    created ()
    {
        this.refreshInformation()
    },

    render ()
    {
        return (
            <div class='wrapper'>
                <div class='header'>
                    <InlineEditableText class='title' placeholder='Titre' v-model={this.title} editable={this.editable} no-html={true} />
                    <InlineEditableText class='time' v-model={this.date} editable={this.editable}
                        max-length={10} auto-height={false} no-html={true} />
                    <inline-svg class='delete-icon' v-show={this.editable} src={require('@/assets/img/cross.svg')}
                        fill='var(--theme-background-text-color-heavy)' on-click={this.onDeleteIconClicked} />
                </div>
                <InlineEditableText class='desc' placeholder="Description de l'événement" v-model={this.description}
                    editable={this.editable} show-toolbar={true} />
                <div v-show={!this.editable} class='actions-bar'>
                    <inline-svg add-class={`icon ${this.isSavedAsFavorite ? 'filled' : 'outlined'}`}
                        src={require('@/assets/img/heart.svg')} on-click={this.onHeartIconClicked} />
                </div>
                <scheduled-publishing-time-picker show={!this.isPublished && this.editable} v-model={this.scheduledPublishingDate} />
                <Button class='save-changes-button' v-show={this.hasEventBeenModified && this.editable} type='secondary' outlined={true}
                    text='Sauvegarder les modifications' on-click={this.onSaveChangesButtonClicked} />

                <image-enlarger ref='imageEnlarger' />
            </div>
        )
    },

    data ()
    {
        return {
            i18n,
            title: '',
            description: '',
            date: '',
            scheduledPublishingDate: null,
            isPublished: false
        }
    },

    mounted ()
    {
        this.$el.addEventListener('click', this.onCardClicked)
    },

    computed:
    {
        hasEventBeenModified ()
        {
            const e = this.event

            return this.title != (e.title || '') || this.description != (e.description || '')
                || !DateUtils.areSameDay(DateUtils.convertDateString(this.date, 'fr', 'iso'), e.date)
                || !DateUtils.areSame(this.scheduledPublishingDate, e.scheduledPublishingDate)
        },

        isSavedAsFavorite ()
        {
            return this.$store.state.favorites.events.includes(this.event.id)
        }
    },

    watch:
    {
        event ()
        {
            this.refreshInformation()
        },
    },

    beforeDestroy ()
    {
        this.$el.removeEventListener('click', this.onCardClicked)
    },

    methods:
    {
        dateTimeFormatter,

        onSaveChangesButtonClicked (event, button)
        {
            this.$emit('save-changes-clicked', this.getFinalEventData(), event, button)
        },

        onDeleteIconClicked ()
        {
            this.$emit('delete-clicked', this.getFinalEventData())
        },

        refreshInformation ()
        {
            this.title = this.event.title
            this.description = this.event.description
            this.date = DateUtils.convertDateString(this.event.date, 'iso', 'fr')
            this.scheduledPublishingDate = this.event.scheduledPublishingDate
            this.isPublished = this.event.isPublished
        },

        getFinalEventData ()
        {
            const date = DateUtils.convertDateString(this.date, 'fr', 'iso')

            return { ...this.event, title: this.title, description: this.description, date, scheduledPublishingDate: this.scheduledPublishingDate }
        },

        async onHeartIconClicked ()
        {
            await this.$store.commit('favorites/setEventState', {eventId: this.event.id, isFavorite: !this.isSavedAsFavorite})
        },

        onCardClicked (e)
        {
            if (e.target instanceof HTMLImageElement)
            {
                this.$refs.imageEnlarger.enlargeImage(e.target.src)
            }
        },
    },

    components:
    {
        InlineEditableText,
        ImageEnlarger,
        Button,
        ScheduledPublishingTimePicker
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.time
{
    .ql-editor
    {
        padding: 0;
    }
}

</style>

<style lang='less'>
@import '~@/styles/main.less';

.wrapper
{
    padding: 5px 20px 15px 20px;
    margin-top: 15px;
    box-shadow: 0 3px 11px 2px rgba(0,0,0,.1);
    background-color: var(--theme-content-background-color);
    border-radius: 5px;
    position: relative;

    > .header
    {
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 40px;
        border-bottom: 1px solid var(--theme-border-color);

        > .title
        {
            font-size: 16px;
            font-weight: bold;
            width: 60%;
        }

        > .time
        {
            font-size: 14px;
            margin-left: auto;
            width: 40%;
            text-align: right;
            padding: 0;
        }

        > .delete-icon
        {
            width: 14px;
            height: auto;
            margin-left: 14px;
            cursor: pointer;
        }
    }

    > .desc
    {
        font-size: 14px;
        padding: 7px 0;
        width: 100%;
        color: var(--theme-text-color-light);
        text-align: left;

        img
        {
            cursor: pointer;
        }
    }

    > .actions-bar
    {
        text-align: end;
        margin-bottom: 5px;
        height: 23px;

        > .icon
        {
            cursor: pointer;
            fill: var(--theme-text-color-light);
            height: 100%;

            &.heart
            {
                &.filled
                {
                    fill: var(--theme-love-color);
                }
            }
        }
    }

    .scheduled-publishing-time-picker
    {
        font-size: 11px;
    }

    > .save-changes-button
    {
        width: 100%;
        margin-top: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/vue-calendar/components/cal-event-item.vue